export class AgencyTokenObj {
    organizationApiId: Number;
    organizationId: Number;
    agencyToken = '';
    apiKeyType = '';
    apiKeyStatus = '';
    effectiveDate: Date = null;
    expiryDate: Date = null;
    reqFirstName = '';
    reqMiddleName = '';
    reqLastName = '';
    reqEmail = '';
    updateProgram = '';
    updateId: Number;
    updateDate: Date;
}
